<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;margin-left: 4px;"><span v-if="question.is_required" class="required-star mr-1">*</span>{{title}}</div>
        </div>
        <div class="col-12"><p class="text-muted px-1 question-description" v-html="formattedText"></p></div>
        <div class="col-12" v-if="question.image_file_name">
            <img class="cursor-pointer" :src="this.context.storageEndpoint + this.question.image_file_name" @click="openPhotoViewer = true"/>
        </div>
        <div v-if="!hasValidAnswer && showInvalid"
            class="col-12 pl-3">
            <div class="alert alert-warning">{{$t('message.please_select_your_answer')}}</div>
        </div>
        <div v-for="optionText in answersWithoutMatchingOptions" :key="optionText">
            <div class="content-unit-container row" @click="toggle(optionText)">
                <div class="col-sm-12 d-flex align-items-center">
                    <input
                        type="checkbox"
                        style="margin-right: 4px;"
                        :checked="choices.indexOf(optionText) > -1"
                    />
                    <span style="padding-left: 4px;white-space: pre-line;">{{optionText}}</span>
                </div>
                <div class="mt-3 w-100" style="margin-left: 32px;position: relative;">
                    <textarea @click.stop="() => {}" class="form-control" :ref="'textarea' + optionText" v-model="noteMap[optionText]"></textarea>
                    <div class="textarea-placeholder" :style="{visibility: showTextArea(optionText) ? 'hidden' : 'visible'}">{{$t('question.note')}}</div>
                </div>
            </div>
        </div>
        <div v-if="dropDownMode">
            <ding-select
                class="ding-select"
                v-model="dingSelectModel"
                :options="question.options"
                :placeholder="$t('message.please_select_your_answer')"
                :preselectFirst="false"
                :allow-multiple-selection="true"
                :disabled="question.options.length === 0"
                value-attribute="id"
                label-attribute="content_unit.text">
                <template slot="multiple-selection-current" slot-scope="slotProps">
                    <div @click="slotProps.open">
                        <div class="dropdown-option-container">
                            <div v-for="item in slotProps.selectedOptions" :key="item.id" class="multiple-selected-option">
                                <div class="option-content-container">
                                    <div v-if ="item.content_unit.thumbnail_file_name">
                                        <img :src="context.storageEndpoint + item.content_unit.thumbnail_file_name" />
                                    </div>
                                    <div class="text">{{item.content_unit.text}}</div>
                                </div>
                                <div v-if="notePlaceholderForOption(item)">
                                    <input @click.stop="() => {}" class="form-control" :ref="'textarea' + item.content_unit.text" :placeholder="notePlaceholderForOption(item)" v-model="noteMap[item.content_unit.text]" />
                                </div>
                            </div>
                        </div>
                        <div class="current-container my-2">
                            <span>{{ choices.length > 0 ? $t('click_to_edit') : $t('click_to_select')}}</span>
                            <span class="down-arrow"></span>
                        </div>
                    </div>
                </template>
                <template slot="multiple-selection-options" slot-scope="scope">
                    <div v-for="option in scope.options" :key="option.id" class="dropdown-select-option" @click="scope.onSelect(option)">
                        <div class="d-flex align-items-center">
                            <input class="d-inline-block mr-2" type="checkbox" :checked="isOptionSelected(option)" />
                            <div class="option-text">{{option.content_unit.text}}</div> 
                        </div>
                        <div v-if ="option.content_unit.file_name">
                            <img width="120" :src="context.storageEndpoint + option.content_unit.file_name" />
                        </div>
                    </div>
                </template>
                <template slot="option" slot-scope="scope">
                    <div class="dropdown-select-option">
                        <div class="option-text">{{scope.option.content_unit.text}}</div> 
                        <div v-if ="scope.option.content_unit.file_name">
                            <img :src="context.storageEndpoint + scope.option.content_unit.file_name" />
                        </div>
                    </div>
                </template>
            </ding-select>
        </div>
        <div class="container-fluid" v-else>
            <div v-for="option in question.options"
                :key="option.id"
                class="row mt-1 mb-1">
                <option-content-unit
                    :context="context"
                    :contentUnit="option.content_unit"
                    :providerId="providerId"
                    :providerQuestionId="question.id"
                    :optionId="option.id"
                    :editing="false"
                    :outerWrapperClass="'col-11'"
                    :enableCrop="true">
                    <div slot-scope="props" slot="template" class="content-unit-container row" @click="toggle(option.content_unit.text)">
                        <div class="col-sm-12 d-flex align-items-center">
                            <input
                                type="checkbox"
                                style="margin-right: 4px;"
                                :checked="choices.indexOf(option.content_unit.text) > -1"
                            />
                            <span style="padding-left: 4px;white-space: pre-line;">{{option.content_unit.text}}</span>
                        </div>
                        <div v-if ="props.thumbnailUrl || props.imageUrl" class="mt-2 mb-2" style="margin-left: 32px;">
                            <img :src="props.imageUrl || props.thumbnailUrl" />
                        </div>
                        <div class="mt-3 w-100" style="margin-left: 32px;position: relative;" v-if="props.extras.note_placeholder">
                            <textarea @click.stop="() => {}" class="form-control" :ref="'textarea' + option.content_unit.text" v-model="noteMap[option.content_unit.text]"></textarea>
                            <div class="textarea-placeholder" :style="{visibility: showTextArea(option.content_unit.text) ? 'hidden' : 'visible'}">{{props.extras.note_placeholder}}</div>
                        </div>
                    </div>
                </option-content-unit>
            </div>
        </div>
        <photo-viewer
            v-if="openPhotoViewer"
            ref="photoViewer"
            :photos="photo"
            :context="context"
            @close="openPhotoViewer = false"></photo-viewer>
    </div>
</template>

<script>
import Constants from '../../constants';
import PhotoViewer from '../common/PhotoViewer.vue';
import dingSelect from '../common/Select';

export default {
    components: { dingSelect, PhotoViewer },
    props: ['question', 'providerId', 'context', 'form', 'answer'],
    data() {
        var answersWithoutMatchingOptions = [];
        var choices = [];
        if (this.answer) {
            if (this.answer.parsedContent && this.answer.parsedContent.choices) {
                choices = this.answer.parsedContent.choices;
            } else if (this.answer.selected_options) {
                // LEGACY: Get all selected choices from `selected_options` which is references-based
                choices = this.answer.selected_options.map((item) => { return item.option.content_unit.text; });
            }
        }

        // loop through choices and see if there's any with no option matched
        choices.forEach((choiceText) => {
            var optionFound = this.answer.question.options.filter((o) => o.content_unit.text === choiceText).length > 0;
            if (!optionFound) {
                answersWithoutMatchingOptions.push(choiceText);
            }
        });

        var dingSelectModel = [];
        if (choices.length > 0) {
            dingSelectModel = choices.map((c) => {
                return this.question.options.find((o) => o.content_unit.text === c)
            });
        }

        var noteMap = {};
        if (this.answer && this.answer.selected_options) {
            noteMap = this.answer.parsedContent.noteMap || {};
        }

        return {
            id: this.question.id,
            content: this.question.content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            showInvalid: false,
            noteMap,
            choices,
            answersWithoutMatchingOptions,
            dingSelectModel,
            openPhotoViewer: false
        };
    },

    computed: {
        title: function() {
            return this.content.meta.title || '';
        },

        photo() {
            if (this.question.image_file_name) {
                return [{
                    path: this.question.image_file_name
                }];
            } else {
                return [];
            }
        },

        hasAnswer() {
            return this.choices.length > 0;
        },

        hasValidAnswer() {
            return this.choices.length > 0;
        },

        dropDownMode() {
            return !!this.content.data.dropdown_mode;
        },
        formattedText() {
            const text = this.content.data.text;
            return text.nl2brIfNotHTML();
        }
    },
    watch: {
        dingSelectModel() {
            this.choices = this.dingSelectModel.map((option) => option.content_unit.text);
        }
    },
    methods: {
        isOptionSelected(option) {
            return this.choices.indexOf(option.content_unit.text) > -1;
        },
        notePlaceholderForOption(option) {
            const extras = option.content_unit.extras;
            const type = typeof extras;

            if (type === 'string') {
                return JSON.parse(extras).note_placeholder;
            } else if (type === 'object') {
                return extras.note_placeholder;
            }
            return null
        },
        showTextArea(text) {
            return this.choices.indexOf(text) > -1 && this.noteMap[text];
        },
        toggle(optionText) {
            const currentIndex = this.choices.indexOf(optionText);
            if (currentIndex >= 0) {
                const replicate = this.choices;
                replicate.splice(currentIndex, 1);
                this.choices = replicate;
                this.noteMap[optionText] = '';
            } else {
                this.choices.push(optionText);
                this.$nextTick(() => {
                    if (this.$refs['textarea' + optionText]) {
                        this.$refs['textarea' + optionText][0].focus();
                    }
                });
            }
        },

        highlightInvalidState() {
            this.showInvalid = true;
        },

        getDataToPersist() {
            return {
                question_id: this.id,
                selected_option_ids: [],
                answer: {
                    noteMap: this.noteMap,
                    choices: this.choices
                },
                answer_id: this.answer ? this.answer.id : null
            };
        }
    }
}
</script>

<style scoped lang="scss">

textarea {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    right: 0;
    bottom: 0;
}

.content-unit-container {
    margin:0 4px;
    padding: 0.8em 0.6em;
}

.content-unit-container:hover {
    background: #EEE;
    border-radius: 4px;
    cursor: pointer;
}

.content-unit-container:active {
    background: #DDD;
    border-radius: 4px;
    cursor: pointer;
}

img {
    width: 100%;
    max-width: 320px;
    border-radius: 4px;
}

.required-star {
    color: red;
    font-weight: bold;
}

.textarea-placeholder {
    white-space: pre-line;
    opacity: 0.5;
    padding: 8px 12px;
}

.multiple-selected-option {
    margin: 4px 0px 0 0;
    align-items: center;
    border-radius: 3px;
    background:#F2F6F7; 
    padding: 8px;

    img {
        width: 200px;
        height: 200px;
    }
    .text {
        padding: 0 8px;
    }
}

.option-content-container {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.dropdown-option-container {
}

.ding-select {
    margin: 0 16px;
}

.dropdown-select-option {
    align-items: center;
    padding: 5px 16px;

    &:hover {
        background:#F2F6F7;
        cursor: pointer;
    }
    .option-text {
        text-align: left;
        flex-grow: 1;
    }

    img {
        width: 200px;
        height: 200px;
        margin-left: 20px;
    }
}
</style>

<i18n>
{
    "en": {
        "click_to_select": "Click to select",
        "click_to_edit": "Click to edit"
    },
    "zh": {
        "click_to_select": "點此選擇",
        "click_to_edit": "點此編輯"
    }
}
</i18n>